// Projde textové uzly v `root` a za jednoslabičné/krátké předložky a spojky
// vloží nezalomitelnou mezeru (\u00A0), aby nezůstaly viset na konci řádku
// (česká typografie). Idempotentní — opakovaný běh už navázané mezery nezdvojí.
// Vybere shopDataLayer podle jazykové mutace (vzor terezacha.cz). EN mutace
// běží na stejném CZ balíku — když en-datalayer.js chybí nebo se nenačte,
// padáme zpět na český. Fallback na legacy globál `shopDataLayer` drží web
// funkční, dokud je na FTP stará verze datalayer.js (před přejmenováním na
// csShopDataLayer). Skeleton v Object.assign chrání před starším nacachovaným
// datalayerem, kterému chybí nově přidaná sekce.
window.getShopDataLayer = function () {
	const csLayer = typeof csShopDataLayer !== "undefined" ? csShopDataLayer : (typeof shopDataLayer !== "undefined" ? shopDataLayer : {});
	const layer = getShoptetDataLayer().language === "en" && typeof enShopDataLayer !== "undefined" ? enShopDataLayer : csLayer;

	return Object.assign({ header: {}, homepage: {}, cookies: {}, advancedOrder: {}, giftTip: {}, buttons: {}, category: {}, megaMenu: {}, emptyContent: {}, cart: {}, productDetail: {}, faq: {}, calendly: {} }, layer);
};

// Na EN mutaci se bindCzechPrepositions nespouští — "a", "i", "o", "do", "no"
// jsou platná anglická slova a nbsp by rozsely chybné mezery po celém webu.
function bindCzechPrepositions(root) {
	const prepositions = new Set([
		"a", "k", "ke", "s", "z", "ze", "v", "ve", "o", "i", "u", "se", "si",
		"za", "před", "bez", "na", "do", "po", "od", "pod", "nad", "přes",
		"mezi", "vedle", "kromě", "okolo", "ať", "co", "který", "které",
		"která", "protože", "nebo",
	]);

	// Tyto elementy přeskakujeme — text uvnitř není sazba (JSON-LD, CSS,
	// editovatelný obsah) a vkládání nbsp by ho rozbilo.
	const skipTags = new Set(["SCRIPT", "STYLE", "TEXTAREA", "NOSCRIPT"]);

	const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
		acceptNode: function (node) {
			return skipTags.has(node.parentNode.nodeName)
				? NodeFilter.FILTER_REJECT
				: NodeFilter.FILTER_ACCEPT;
		},
	});

	let node;
	while ((node = walker.nextNode())) {
		const words = node.nodeValue.split(/(\s+)/);
		let changed = false;

		for (let i = 0; i < words.length - 1; i++) {
			if (!/\s+/.test(words[i]) && prepositions.has(words[i].toLowerCase())) {
				words[i] = words[i] + "\u00A0";
				words.splice(i + 1, 1); // odstraníme následující mezeru
				changed = true;
			}
		}

		if (changed) {
			node.nodeValue = words.join("");
		}
	}
}

$(document).ready(function () {
	window.myDataLayer = getShoptetDataLayer();

	if (myDataLayer.language !== "en") {
		bindCzechPrepositions(document.body);
	}
});

// Re-run po AJAX dotažení obsahu — Shoptet vykresluje části stránky asynchronně,
// jednorázový běh po loadu by nově vložený text nepokryl.
[
	"ShoptetDOMPageContentLoaded", // filtrování, řazení, stránkování kategorie
	"ShoptetDOMPageMoreProductsLoaded", // "načíst další"
	"ShoptetDOMSearchResultsLoaded", // výsledky vyhledávání
	"ShoptetDOMCartContentLoaded", // obsah košíku
	"ShoptetDOMAdvancedOrderLoaded", // advanced-order popup
].forEach(function (eventName) {
	document.addEventListener(eventName, function () {
		if (getShoptetDataLayer().language !== "en") {
			bindCzechPrepositions(document.body);
		}
	});
});
